/**
 * @generated SignedSource<<24b464e2581a4de8eeb11d95f6f0aa26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSearchListItem_storeProductSearchHit$data = {
  readonly id: string | null;
  readonly nameHighlights: ReadonlyArray<{
    readonly isHighlighted: boolean;
    readonly text: string;
  }> | null;
  readonly product: {
    readonly id: string;
    readonly imageUrl: string | null;
    readonly name: string | null;
    readonly partNumber: string | null;
  };
  readonly " $fragmentType": "ProductSearchListItem_storeProductSearchHit";
};
export type ProductSearchListItem_storeProductSearchHit$key = {
  readonly " $data"?: ProductSearchListItem_storeProductSearchHit$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSearchListItem_storeProductSearchHit">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSearchListItem_storeProductSearchHit",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProductSearchHitHighlightPart",
      "kind": "LinkedField",
      "name": "nameHighlights",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHighlighted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProduct",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "partNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProductSearchHit",
  "abstractKey": null
};
})();

(node as any).hash = "3d6d88cf8681a326dfe70d9504fc583d";

export default node;
